import React, { useRef, useState } from "react";
import Modal from 'react-modal';
import CloseIcon from '@mui/icons-material/Close';
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const VerifyDrivingLicense = () => {

    const { baseUrl, selectedStaff, openToast } = useGlobalContext();
    const [isLoading, setIsLoading] = useState(false);
    const [drivingLicense, setDrivingLicense] = useState({
        number: selectedStaff?.staffDetails?.staff_bg_verification?.driving_license_number,
        status: selectedStaff?.staffDetails?.staff_bg_verification?.driving_license_status,
        verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.driving_license_file,
    });
    const [drivingLicense1, setDrivingLicense1] = useState({
        verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.driving_license_file || null,
    });
    let subtitle;

    const [modalIsOpen2, setIsOpen2] = React.useState(false);
    function openModal2() {
        setIsOpen2(true);
    }
    function afterOpenModal2() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#000';

    }

    function closeModal2() {
        setIsOpen2(false);
    }

    const fileInputRef = useRef(null);

    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    // Function to handle file selection
    async function submitDrivingLicense() {
        setIsLoading(true);
        if (!drivingLicense?.number || !drivingLicense?.verificationFile) {
            openToast(" Provide either Driving License number or upload file", "warning");
            return;
        }

        console.log(drivingLicense);
        const newFormData = new FormData();
        newFormData.append("driving_license_number", drivingLicense?.number);
        newFormData.append("verificationFile", drivingLicense?.verificationFile);

        try {
            const response = await fetch(baseUrl + "bg-verification/" + selectedStaff.staffDetails.id + "/verify/driving_license", {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${Cookies.get("token")}`,
                },
                body: newFormData
            });


            console.log(response);

            if (response.status === 201) {
                const result = await response.json();
                console.log(result);
                setDrivingLicense({ ...drivingLicense, number: result?.data?.driving_license_number, status: result?.data?.driving_license_status, verificationFile: result?.data?.driving_license_file });
                openToast("Driving License successfully updated or created", "success");
                closeModal2();
            } else {
                openToast("An error occurred while adding or updating Driving License", "error");
            }
        } catch (error) {
            console.error("Error adding or updating Driving License:", error);
            openToast("An error occurred while adding or updating Driving License", "error");
        }
        finally {
            setIsLoading(false);
        }
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setDrivingLicense({ ...drivingLicense, verificationFile: file });
        if (file) {
            const fileURL = URL.createObjectURL(file); // Create a blob URL for the file
            setDrivingLicense1({ ...drivingLicense1, verificationFile: fileURL }); // Update state with the file URL
        }
    };


    return (
        <div className='relative flex flex-col xl:pt-[30px] w-full'>
            <div className='top-0 flex justify-between items-center bg-white pr-0 xl:pr-[0px] pb-[10px] pl-[0] w-[100%]'>
                <h3 className='font-medium text-[13px] md:text-[15px]'>Driving License Verification</h3>
                <button className={'second-btn ' + (isLoading && "opacity-50 animate-pulse cursor-not-allowed")} disabled={isLoading} onClick={submitDrivingLicense}>
                    Update Driving
                </button>
            </div>

            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Driving License</h4>
                <p className='font-light'>{drivingLicense?.number}</p>
                <button className='second-btn' onClick={openModal2}  >
                    Add
                </button>

            </div>


            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Verification Status
                </h4>
                <p className='font-light'>{drivingLicense?.status}</p>

            </div>


            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Proofs</h4>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                />
                <div className="flex justify-center items-center bg-gray-100 border rounded-md w-[100px] h-[50px] image-container">
                    {drivingLicense1?.verificationFile ? (
                        typeof drivingLicense1.verificationFile === "string" ? (
                            <img
                                src={drivingLicense1.verificationFile}
                                alt="Selected File"
                                className="rounded-md max-w-full max-h-full"
                            />
                        ) : (
                            <span className="text-gray-500 text-sm">Invalid file</span>
                        )
                    ) : (
                        <span className="text-gray-500 text-sm">No file</span>
                    )}
                </div>
                <button className='second-btn' onClick={handleUploadClick}>
                    Upload
                </button>

            </div>


            <Modal
                isOpen={modalIsOpen2}
                onAfterOpen={afterOpenModal2}
                onRequestClose={closeModal2}
                contentLabel="Example Modal"
                className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"

            >
                <h2 ref={(_subtitle) => (subtitle = _subtitle)} className='p-3 border-b-1 text-[13px] xl:text-[15px]'>Add Driving License</h2>
                <button onClick={closeModal2} className='top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold'><CloseIcon className='text-white' /></button>
                <div className=''>
                    <div className='p-[10px] border border-t field-modal modal-field'>
                        <label className='font-medium text-[13px] xl:text-[14px]'>Driving License
                        </label><br />
                        <input type='text' placeholder="Enter Driving License Number" className='border-1 newsetup3 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none' value={drivingLicense?.number} onChange={(e) => setDrivingLicense({ ...drivingLicense, number: e.target.value })} /><br />


                    </div>
                    <div className='flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t'>
                        <button className='first-btn' onClick={closeModal2}>Cancel</button>
                        <button className='second-btn' onClick={closeModal2}>Save </button>
                    </div>
                </div>
            </Modal>

        </div>
    )
}

export default VerifyDrivingLicense